var _linearGradient, _path, _linearGradient2, _path2, _path3, _path4, _path5, _linearGradient3, _path6, _linearGradient4, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8Home(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "240px",
    height: "240px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "jv689zNUBazMNK6AOyXtga",
    x1: 6,
    x2: 42,
    y1: 41,
    y2: 41,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c8d3de"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c8d3de"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#jv689zNUBazMNK6AOyXtga)",
    d: "M42,39H6v2c0,1.105,0.895,2,2,2h32c1.105,0,2-0.895,2-2V39z"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "jv689zNUBazMNK6AOyXtgb",
    x1: 14.095,
    x2: 31.385,
    y1: 10.338,
    y2: 43.787,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fcfcfc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.495,
    stopColor: "#f4f4f4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.946,
    stopColor: "#e8e8e8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e8e8e8"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#jv689zNUBazMNK6AOyXtgb)",
    d: "M42,39H6V20L24,3l18,17V39z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#de490d",
    d: "M13,25h10c0.552,0,1,0.448,1,1v17H12V26C12,25.448,12.448,25,13,25z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24,4c-0.474,0-0.948,0.168-1.326,0.503l-5.359,4.811L6,20v5.39L24,9.428L42,25.39V20L30.685,9.314 l-5.359-4.811C24.948,4.168,24.474,4,24,4z",
    opacity: 0.05
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24,3c-0.474,0-0.948,0.167-1.326,0.5l-5.359,4.784L6,18.909v5.359L24,8.397l18,15.871v-5.359 L30.685,8.284L25.326,3.5C24.948,3.167,24.474,3,24,3z",
    opacity: 0.07
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "jv689zNUBazMNK6AOyXtgc",
    x1: 24,
    x2: 24,
    y1: 1.684,
    y2: 23.696,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d43a02"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b9360c"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#jv689zNUBazMNK6AOyXtgc)",
    d: "M44.495,19.507L25.326,2.503C24.948,2.168,24.474,2,24,2s-0.948,0.168-1.326,0.503 L3.505,19.507c-0.42,0.374-0.449,1.02-0.064,1.43l1.636,1.745c0.369,0.394,0.984,0.424,1.39,0.067L24,7.428L41.533,22.75 c0.405,0.356,1.021,0.327,1.39-0.067l1.636-1.745C44.944,20.527,44.915,19.881,44.495,19.507z"
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "jv689zNUBazMNK6AOyXtgd",
    x1: 28.05,
    x2: 35.614,
    y1: 25.05,
    y2: 32.614,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#33bef0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0a85d9"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#jv689zNUBazMNK6AOyXtgd)",
    d: "M29,25h6c0.552,0,1,0.448,1,1v6c0,0.552-0.448,1-1,1h-6c-0.552,0-1-0.448-1-1v-6 C28,25.448,28.448,25,29,25z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Home);
export default __webpack_public_path__ + "static/media/icons8-home.c73782f8450069768f1ce7a7aa75fb19.svg";
export { ForwardRef as ReactComponent };